import { ApiInvoiceEmailDelivery } from '@Model';
import { emailDeliveryColumns } from './emailDeliveryColumns';
import { Table } from '@synqo/frontend-component-library';
import { FC } from 'react';

interface EmailDeliveryTableProps {
    items: ApiInvoiceEmailDelivery[];
}

export const EmailDeliveryTable: FC<EmailDeliveryTableProps> = ({ items }) => {
    return (
        <Table<ApiInvoiceEmailDelivery>
            items={items}
            disableTopToolbar={true}
            name={'EmailDelivery'}
            columns={emailDeliveryColumns}
            key={items.length}
            initialDensity="xs"
            initialSorting={{ columnName: 'sent_date', direction: 'desc' }}
            canCreate={false}
        />
    );
};
